import { API_CONFIG } from '../config/api';
import { internalApi } from './internalApi';

export const placeService = {
  autocomplete: async (input, sessionToken) => {
    const trimmed = input.trim();
    if (trimmed.length < 3) return [];

    const params = { input: trimmed };
    if (sessionToken) params.session_token = sessionToken;

    const response = await internalApi.get(
      API_CONFIG.ENDPOINTS.PLACE_AUTOCOMPLETE,
      { params }
    );
    return response.data.results || [];
  },

  getPlaceDetails: async (placeId, sessionToken) => {
    const params = {};
    if (sessionToken) params.session_token = sessionToken;

    const response = await internalApi.get(
      API_CONFIG.ENDPOINTS.PLACE_DETAILS(placeId),
      { params }
    );
    return response.data.result;
  },
};
